import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpSupportFormService} from './dcp-support-form.service';

import {ConfigModule} from '@spartacus/core';
import {SupportFormPageComponent} from './stand-alone/support-form-page.component';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SupportFormPageComponent: {
          component: SupportFormPageComponent,
        },
      },
    }),
    SupportFormPageComponent,
  ],
  providers: [DcpSupportFormService],
})
export class DcpSupportFormModule {}
